import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-wrapper" }

import { ref, onMounted, onUnmounted } from "vue";

// 接收传入的文本内容

export default /*@__PURE__*/_defineComponent({
  __name: 'TextWithEllipsis',
  props: {
  text: {
    type: String, // 设置为字符串类型
    required: true, // 必须传入
  },
},
  setup(__props) {

const props = __props;

// 响应式数据区
const isExpanded = ref(false); // 控制文本是否展开
const showArrow = ref(false); // 控制是否显示箭头
const textContainer = ref(null); // 文本容器的引用

// 生命周期钩子区
onMounted(() => { //NOSONAR
  checkTextOverflow(); // 页面加载时检查文本是否超出两行
  window.addEventListener("resize", checkTextOverflow); // 窗口大小变化时重新检测文本溢出
});

onUnmounted(() => {
  // 在组件销毁时移除事件监听，避免内存泄漏
  window.removeEventListener("resize", checkTextOverflow);
});

// 核心方法区
// 切换展开状态
const toggleExpand = () => {
  isExpanded.value = !isExpanded.value; // 切换 isExpanded 布尔值
};

// 检查文本是否溢出
const checkTextOverflow = () => {
  if (textContainer.value) {
    const container = textContainer.value;
    if (container.scrollHeight > container.clientHeight) {
      showArrow.value = true; // 如果文本溢出，显示箭头
    } else {
      showArrow.value = false; // 否则不显示箭头
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["text-ellipsis", { expanded: isExpanded.value }]),
      ref_key: "textContainer",
      ref: textContainer
    }, _toDisplayString(__props.text), 3),
    (showArrow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["expand-button", { expanded: isExpanded.value }]),
          onClick: toggleExpand
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}
}

})